// Enlaces a la documentación oficial (docs.nuatalker.com). Se muestran al final del drawer de
// "Información" de cada pantalla y en el Home.
const DOCS_BASE_URL = 'https://www.docs.nuatalker.com/#';

export const DOCS_URLS = {
  guides: `${DOCS_BASE_URL}/guias`,
  chatInstallation: `${DOCS_BASE_URL}/guia/instalacion-chat`,
  flows: `${DOCS_BASE_URL}/guia/flujos`,
  inbox: `${DOCS_BASE_URL}/guia/manual-bandeja-nua`,
  webWidget: `${DOCS_BASE_URL}/guia/manual-widget-web`,
};
